import TaskFilterBar from '../TaskFilterBar';
import TaskList from '../TaskList';

import TaskHeader from './TaskHeader';
import TaskLayout from './TaskLayout';
import useTaskReport from './hooks';

const TaskPage = () => {
  const { taskReports, isLoading } = useTaskReport();

  return (
    <TaskLayout>
      <div>
        <TaskHeader />
        <TaskFilterBar />
      </div>
      <TaskList taskReports={taskReports} loading={isLoading} />
    </TaskLayout>
  );
};

export default TaskPage;
